import React from "react";
import { useMenuItem } from "react-aria";
import { Node, TreeState } from "react-stately";
import { Prettify } from "../../utils/types";
import * as S from "./styled";
import { Typography } from "../Typography";

export type MenuItemProps<T extends object> = Prettify<{
    state: TreeState<T>;
    item: Node<T>;
}>;

const MenuItem = <T extends object>({ item, state }: MenuItemProps<T>) => {
    const ref = React.useRef(null);
    const { menuItemProps, isSelected, isDisabled, isFocused } = useMenuItem({ key: item.key }, state, ref);

    return (
        <S.ListItem
            $isSelected={isSelected}
            $isDisabled={isDisabled}
            $isFocused={isFocused}
            as="li"
            {...menuItemProps}
            ref={ref}
        >
            <Typography as="div" variant="label-x-small-medium">
                {item.rendered}
            </Typography>
            {isSelected && <S.CheckIcon size={S.ITEM_CHECK_ICON_SIZE} />}
        </S.ListItem>
    );
};

export default MenuItem;
